import { createSlice } from "@reduxjs/toolkit";
import {
  buildPermissionKeyList,
  getStoredAccessContext,
} from "../Utils/access/permissionHelpers";

const readInitial = () => {
  const ctx = getStoredAccessContext();
  if (!ctx) {
    return { context: null, permissionKeys: [] };
  }
  return {
    context: ctx,
    permissionKeys: buildPermissionKeyList(ctx),
  };
};

const init = readInitial();

const accessSlice = createSlice({
  name: "access",
  initialState: {
    context: init.context,
    permissionKeys: init.permissionKeys,
  },
  reducers: {
    setAccessContext: (state, action) => {
      const ctx = action.payload;
      state.context = ctx;
      state.permissionKeys = buildPermissionKeyList(ctx);
    },
    clearAccess: (state) => {
      state.context = null;
      state.permissionKeys = [];
    },
  },
});

export const { setAccessContext, clearAccess } = accessSlice.actions;
export default accessSlice.reducer;
